import React, { useMemo } from 'react'
import { FormattedMessage } from 'react-intl'

import {
  Message,
  MessageFooter,
  MessageOwner,
  MessageTime,
} from '~/DesignSystem/components/messages'
import { Icon } from '~/DesignSystem/Icon'

import { MessageActions } from './MessageActions'

type MessageProps = React.ComponentProps<typeof Message>

type IncomingActionsMessageProps = {
  owner?: string
  time?: number
} & Omit<MessageProps, 'direction' | 'variant'> & {
    direction?: MessageProps['direction']
    variant?: MessageProps['variant']
  }

function IncomingActionsMessage({
  owner,
  time,
  children,
  direction = 'incoming',
  variant = 'secondary',
  ...props
}: IncomingActionsMessageProps) {
  const { content, actions } = useMemo(() => {
    return React.Children.toArray(children).reduce(
      (acc, child) => {
        if (React.isValidElement(child) && child.type === MessageActions) {
          acc.actions.push(child)
        } else {
          acc.content.push(child)
        }
        return acc
      },
      { content: [] as React.ReactNode[], actions: [] as React.ReactNode[] },
    )
  }, [children])

  return (
    <Message direction={direction} variant={variant} {...props}>
      <MessageOwner picture={<Icon value="ai" />}>
        {owner || <FormattedMessage id="chat.agentMessage.displayName" />}
      </MessageOwner>
      {content}
      {!!actions.length && <MessageFooter>{actions}</MessageFooter>}
      {!!time && <MessageTime>{time}</MessageTime>}
    </Message>
  )
}

export { IncomingActionsMessage }
